import React from 'react';

const prepaidStoreCodes = [
  'PBAU',
  'PBMY',
  'PBCA',
  'PBUS',
  'PBSG',
  'PBPH',
  'PBHK',
  'PBNZ',
  'PBTH',
  'PBUK',
  'PBAE',
  'PBID',
  'PBEU',
];

const muslimProStoreCodes = [
  'MPMY',
  'MPEU',
  'MPID',
  'MPUS',
  'MPUK',
];

export const isPrepaidStore = ({ code = '' }) => prepaidStoreCodes.includes(code);

export const isMuslimProStore = ({ code = '' }) => muslimProStoreCodes.includes(code);

export const willHideOnMuslimPro = WrapperComponent => ((props) => {
  const { store } = props;
  const { code = '' } = store;

  return (!code || isMuslimProStore(store)) ? null : <WrapperComponent {...props}/>;
});



// WEBPACK FOOTER //
// ./src/Common/Store/Store.js